var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.245 0.817547C12.3318 -0.26926 14.0939 -0.26926 15.1807 0.817547C16.2222 1.85907 16.2656 3.52075 15.3109 4.61395L15.1807 4.75322L5.57486 14.359C5.36977 14.5641 5.12304 14.7217 4.85216 14.8215L4.68689 14.8744L0.631913 15.9803C0.285324 16.0748 -0.0347398 15.7862 0.00280818 15.4457L0.0179721 15.3663L1.12387 11.3113C1.20019 11.0315 1.33626 10.7723 1.52192 10.5513L1.63919 10.4234L11.245 0.817547ZM10.3848 3.09244L2.34629 11.1305C2.254 11.2228 2.18097 11.3319 2.13091 11.4516L2.08864 11.5745L1.212 14.7852L4.42377 13.9096C4.50772 13.8867 4.58795 13.853 4.66258 13.8097L4.77008 13.7377L4.86776 13.6519L12.9058 5.61344L10.3848 3.09244ZM14.4736 1.52465C13.816 0.867053 12.7725 0.83052 12.072 1.41505L11.9521 1.52465L11.0918 2.38544L13.6128 4.90644L14.4736 4.04612C15.1312 3.38852 15.1677 2.34503 14.5832 1.64456L14.4736 1.52465Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconSvg);
export default __webpack_public_path__ + "static/media/edit-icon-svg.9aae8607a3fe473782dd204158ac9484.svg";
export { ForwardRef as ReactComponent };